import React from "react";
import PropTypes from "prop-types";
import ButtonBase from "@material-ui/core/ButtonBase";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: theme.spacing(2),
  },
  gridItemFlex: {
    display: "flex",
  },
  gridItemFlexCenter: {
    justifyContent: "center",
  },
  label: {
    paddingBottom: 0,
    paddingTop: 0,
    color: "oklch(55.4% .046 257.417)",
  },
  loginButton: {
    border: "none",
    backgroundColor: "var(--gc-gold-btn)",
    color: "white !important",
    marginRight: theme.spacing(1),
    padding: `8px 32px`,
    fontWeight: 700,
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "var(--gc-gold-btn-hover) !important",
      color: "white",
      transform: "scale(105%)",
    },
    "&:disabled": {
      color: "white !important",
      cursor: "not-allowed",
    },
  },
  mediumHorizontalSpace: {
    width: theme.spacing(1),
  },
  smallHorizontalSpace: {
    width: theme.spacing(0.5),
  },
  textAction: {
    color: "var(--gc-action-strong)",
  },
  textBold: {
    fontWeight: theme.typography.fontWeightBold,
  },
  textItalic: {
    fontStyle: "italic",
  },
  textUnderline: {
    textDecoration: "underline",
  },
  buttonProgress: {
    color: "#fff",
  },
}));

function MembershipActionFooter({
  captionText,
  onPrimaryAction,
  onSecondaryAction,
  isPrimaryActionDisabled,
  primaryActionText,
  secondaryActionText,
  isPerformingPrimaryAction = false,
}) {
  const classes = useStyles();

  //Per evitare di creare regressioni, indico che l'azione non dovrà essere mostrata solo se tutti e tre i valori sono settati.
  //Questo perché nella form di login è stata imposta questa condizione per nascondere la registrazione
  const showSecondAction =
    captionText && onSecondaryAction && secondaryActionText;

  return (
    <Grid
      container
      direction="column"
      spacing={1}
      className={classes.marginTop}
    >
      <Grid item xs={12}>
        <button
          className={classes.loginButton}
          disabled={isPrimaryActionDisabled}
          onClick={onPrimaryAction}
        >
          {isPerformingPrimaryAction ? (
            <CircularProgress size={14} className={classes.buttonProgress} />
          ) : (
            <>{primaryActionText}</>
          )}
        </button>
      </Grid>
      {showSecondAction && (
        <Grid
          className={`${classes.gridItemFlex} ${classes.marginTop}`}
          item
          xs={12}
        >
          <Typography className={classes.label} variant="caption">
            {captionText}
          </Typography>
          <div className={classes.mediumHorizontalSpace} />
          <ButtonBase onClick={onSecondaryAction}>
            <Typography
              className={`${classes.label} ${classes.textAction} ${classes.textBold} ${classes.textUnderline}`}
              variant="caption"
            >
              {secondaryActionText}
            </Typography>
            <div className={classes.smallHorizontalSpace} />
            <Typography
              className={`${classes.textAction} ${classes.textBold}`}
              variant="caption"
            >
              &rarr;
            </Typography>
          </ButtonBase>
        </Grid>
      )}
    </Grid>
  );
}

MembershipActionFooter.propTypes = {
  captionText: PropTypes.string,
  onPrimaryAction: PropTypes.func.isRequired,
  onSecondaryAction: PropTypes.func,
  isPrimaryActionDisabled: PropTypes.bool.isRequired,
  primaryActionText: PropTypes.string.isRequired,
  secondaryActionText: PropTypes.string,
  isPerformingPrimaryAction: PropTypes.bool,
};

export default MembershipActionFooter;
